<template>
  <div class="main">
    <Nav
      @loggedout = "isLoggedIn = false"
    />
    <div class="container">
      <div class="row mb-x4">
        <div class="col-lg-8">
          <h2>Welcome to Zero Stack</h2>
          <p v-if="isLoggedIn">Hello {{ userData.name }}</p>
        </div>
      </div>
      <div class="row mb-x2">
        <div class="col">
          <h3>Basic CMS Example</h3>
          <p class="mb-x2"><template v-if="isLoggedIn">H</template><template v-else>Login and h</template>ead over to the CMS demo to edit this content</p>
          <ExampleComponent
            :titleProp="titleProp"
            :descProp="descProp"
          />
        </div>
      </div>
      <div class="row" v-if="isLoggedIn">
        <div class="col-md mb-x2">
          <div class="example zero-card p-x2">
            <h4>CMS Demo Admin Panel</h4>
            <p class="mb-x2">Edit the contents on this page through the CMS admin panel.</p>
            <router-link to="/cms" class="zero-btn zero-btn-standard zero-btn-primary">
              CMS Admin Panel
            </router-link>
          </div>
        </div>
        <div class="col-md">
          <div class="example zero-card p-x2">
            <h4>Events Demo Admin Panel</h4>
            <p class="mb-x2">Check out the events management demo.</p>
            <router-link to="/events" class="zero-btn zero-btn-standard zero-btn-primary">
              Events Admin Panel
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import mainSchema from '@/schema/mainschema.json'
import ExampleComponent from '@/components/ExampleComponent.vue'
import Nav from '@/components/Nav.vue'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const localApiURL = 'http://localhost:8000/api/cms'
// const remoteApiURL = 'https://timothyreeder.com/alpha/zero-api/public/api/cms'

const apiChoice = localApiURL

export default {
  name: 'home',
  components: {
    ExampleComponent,
    Nav
  },
  data () {
    return {
      isLoading: false,
      titleProp: 'CMS Sample Card Title',
      descProp: 'This can be edited',
      mainData: mainSchema,
      output: 'output is empty',
      userToken: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      }
    }
  },
  created () {
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
    }
  },
  methods: {
    getApi () {
      this.isLoading = true
      axios
        .get(apiChoice, {
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        })
        .then((response) => {
          // transfer the response
          this.mainData = response.data.data
          // stop loading
          this.isLoading = false
        })
        .catch((error) => {
          console.log(error.response.data.error)
          this.isLoading = false
        })
    },
    testApiGet () {
      console.log('test initiated')
      axios
        .get(apiChoice, {
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
        .then((response) => {
          // do something with response.data.data
          console.log(response.data)
          this.output = response.data
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    testApiPost () {
      console.log('test initiated')
      let payload = {
        'title': 'hello world from vue',
        'blurb_one': 'lorem ipsum',
        'example_file': 'none'
      }
      // let token = this.$auth0.authToken
      let token = this.$auth0.authToken
      console.log(token)
      // let token = ''
      axios
        .post(apiChoice, payload, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + token
          }
        })
        .then((response) => {
          // do something with response.data.data
          console.log(response.data)
          this.output = response.data
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    testLogin () {
      this.$auth0.loginWithRedirect()
    },
    testLogout () {
      this.$auth0.logout({
        returnTo: window.location.origin
      })
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content .menu-info{
  h2{
    display: block;
  }
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
